<template>
  <div class="profile-image">
    <img :src="src" :alt="alt" />
  </div>
</template>
<script>
export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
$profile-image-size: 50px;

.profile-image {
  display: inline-block;
  height: $profile-image-size;
  width: $profile-image-size;

  & > img {
    max-width: $profile-image-size;
    max-height: $profile-image-size;
    border-radius: 50%;
  }
}
</style>
